let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Gzf8")).then(() => parcelRequire('hdQQK'));